export const inviteFriendInitialValues = {
  email: "",
};
